export const generatedItemMarker = 'gen\0';
